import { User } from './user';

export class Session {
  id: number = 111;
  token: string = '';
  users: User = new User();
}
